<template>
    <BoxLayout :logo="this.logo">
        <div class="upload">
            <i class="bi bi-cloud-arrow-up-fill upload-image"></i>
        </div>
        <div class="text-center">
           The files you select will upload automatically, you can close the page once you are finished
        </div>
        <FileInput
            label=""
            v-model="photos"
            :v="v$.photos"
            :allowedExtensions="['jpg', 'jpeg', 'png', 'heic', 'mp4', 'webm', 'mov']"
            url="/api/v1/qr/files"
            completeUrl="/api/v1/qr/files/complete"
            :token=this.token
        />
    </BoxLayout>
</template>
<style scoped lang="scss">
.upload {
    display: flex;
    justify-content: center;
}
.upload-image {
    font-size: 3rem;
    color: $swift-fresh-green;
}
</style>
<script>
    import FileInput from '@/components/FileInput.vue';
    import BoxLayout from '@/components/BoxLayout.vue';
    import useVuelidate from '@vuelidate/core';
    import api from '@/services/api';

    export default {
        setup () {
            return {
                v$: useVuelidate()
            }
        },
        props: {
            token: {
                required: true,
            },
        },
        data() {
            return {
                photos: [],
                logo: 'connect',
            }
        },
        methods: {
            getLogo: function () {
                const query = this.$route.query.logo;
                if (['connect', 'lab'].includes(query)) {
                    this.logo = query;
                }
            },
        },
        validations () {
            return {
                photos: {}
            }
        },
        components: {            
            BoxLayout,
            FileInput,
        },
        mounted() {
            api.get('/sanctum/csrf-cookie');
            this.getLogo();
        },
    }
</script>